import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { RefreshCw, ClipboardList, Recycle, Users, BarChart3, Phone } from "lucide-react";
import { toast } from "sonner";
import { adminStatsPuntoLimpio, adminSyncPuntoLimpio } from "@/api";
import CheckinsPendientes from "./CheckinsPendientes";
import EventosHistorial from "./EventosHistorial";
import Apuntados from "./Apuntados";
import PuntoLimpioTelefonoDialog from "./PuntoLimpioTelefonoDialog";

export default function PuntoLimpioPanel() {
  const [stats, setStats] = useState(null);
  const [syncing, setSyncing] = useState(false);
  const [showTelefono, setShowTelefono] = useState(false);
  const [pendientesKey, setPendientesKey] = useState(0);

  const loadStats = useCallback(() => adminStatsPuntoLimpio().then(setStats).catch(() => {}), []);

  useEffect(() => { loadStats(); }, [loadStats]);

  const handleSync = async () => {
    setSyncing(true);
    try {
      const res = await adminSyncPuntoLimpio(false);
      toast.success(`Sincronizado: ${res.eventos} eventos`);
      loadStats();
    } catch {
      toast.error("No se pudo sincronizar con ArcGIS");
    } finally {
      setSyncing(false);
    }
  };

  const handleTelefonoCreated = () => {
    loadStats();
    setPendientesKey((k) => k + 1);
  };

  return (
    <div data-testid="puntolimpio-admin-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <div className="flex gap-4 text-sm text-gray-500">
          {stats && (
            <>
              <span><ClipboardList className="w-3.5 h-3.5 inline mr-1 text-municipal" />{stats.pendientes} pendientes</span>
              <span><Recycle className="w-3.5 h-3.5 inline mr-1 text-valoriza-green" />{stats.total_eventos} eventos totales</span>
              <span><Users className="w-3.5 h-3.5 inline mr-1 text-dorado" />{stats.apuntados} apuntados</span>
            </>
          )}
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={() => setShowTelefono(true)} className="border-municipal text-municipal" data-testid="puntolimpio-telefono-btn">
            <Phone className="w-4 h-4 mr-2" /> Registrar entrega telefónica
          </Button>
          <Link to="/punto-limpio/estadisticas" target="_blank" rel="noopener noreferrer">
            <Button variant="outline" size="sm" className="border-dorado text-dorado" data-testid="ver-estadisticas-btn">
              <BarChart3 className="w-4 h-4 mr-2" /> Ver estadísticas
            </Button>
          </Link>
          <Button variant="outline" size="sm" onClick={handleSync} disabled={syncing} className="border-municipal text-municipal" data-testid="sync-arcgis-btn">
            <RefreshCw className={`w-4 h-4 mr-2 ${syncing ? "animate-spin" : ""}`} /> Sincronizar con ArcGIS
          </Button>
        </div>
      </div>

      <Tabs defaultValue="pendientes">
        <TabsList className="mb-4">
          <TabsTrigger value="pendientes" data-testid="subtab-pendientes">Check-ins pendientes</TabsTrigger>
          <TabsTrigger value="historico" data-testid="subtab-historico">Histórico</TabsTrigger>
          <TabsTrigger value="apuntados" data-testid="subtab-apuntados">Apuntados a bonificación</TabsTrigger>
        </TabsList>
        <TabsContent value="pendientes"><CheckinsPendientes key={pendientesKey} onConfirmed={loadStats} /></TabsContent>
        <TabsContent value="historico"><EventosHistorial /></TabsContent>
        <TabsContent value="apuntados"><Apuntados /></TabsContent>
      </Tabs>

      <PuntoLimpioTelefonoDialog open={showTelefono} onClose={() => setShowTelefono(false)} onCreated={handleTelefonoCreated} />
    </div>
  );
}
